export default "__VITE_ASSET__CvIhxU4N__"